import gql from 'graphql-tag';
import Util from './Util';

const IP_LOCATION = gql`
query {
  ipLocation {
    label
    country
    adminDistrict
    adminDistrict2
    locality
    latitude
    longitude
  }
}
`;

const POINT_LOCATION = gql`
query pointLocation($point: Point) {
  pointLocation(point: $point) {
    label
    country
    adminDistrict
    adminDistrict2
    locality
    latitude
    longitude
  }
}
`;

const USER_LOCATION_COOKIE = "USER_LOCATION"

class Location {
    static isGpsEnabled() {
        return Util.getCookie("TRACKING_ENABLED") === "true"
    }

    static setGpsEnabled(enabled) {
        Util.setCookie("TRACKING_ENABLED", enabled)
    }

    static setUserLocation(location) {
        const jsonLocation = JSON.stringify(location)
        const b64Location = btoa(jsonLocation)
        Util.setCookie(USER_LOCATION_COOKIE, b64Location, 60 * 60);
    }

    static getUserLocation() {
        const b64Location = Util.getCookie(USER_LOCATION_COOKIE)
        if (!b64Location) {
            return null
        }
        const jsonLocation = atob(b64Location)
        return JSON.parse(jsonLocation)
    }

    static getLocator(sendLocator) {
        this.getGPSLocation(
            location => {
                sendLocator({coordinates: {latitude: location.coords.latitude, longitude: location.coords.longitude}})
            },
            error => {
                sendLocator({useRequestIpAddress: true})
            }
        )
    }

    static getGPSLocation(success, error) {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    var coords = position?.coords;
                    if (coords.latitude && coords.longitude) {
                        success?.(position)
                    } else {
                        error?.("Unable to get coordinates")
                    }
                },
                err => error?.(err.message),
                {
                    enableHighAccuracy: false,
                    timeout: 5000,
                    maximumAge: 0
                }
            )
        } else {
            error?.("Geolocation is not supported by this browser.")
        }
    }

    static getLocation(client, success, onError) {
        //First try to use GPS
        Location.getGPSLocation(
            position => {
                client.query({
                    query: POINT_LOCATION,
                    variables: { point: { latitude: position.coords.latitude, longitude: position.coords.longitude } }
                }).then(data => {
                    if (data.data.pointLocation === null || data.data.pointLocation.label === null) {
                        onError?.({ message: 'Unable to determine location' });
                    } else {
                        success(data.data.pointLocation);
                    }
                })
            },
            error => {
                //TODO IF timeout, retry
                console.log(error)
                client.query({
                    query: IP_LOCATION
                }).then(data => {
                    if (data.data.ipLocation === null || data.data.ipLocation.label === null) {
                        onError?.({ message: 'Unable to determine location: ' + error });
                    } else {
                        success(data.data.ipLocation);
                    }
                })
            }
        )
    }
}

export default Location;